import { render } from "./payment-required.vue?vue&type=template&id=51d5bf88&lang=pug"
import script from "./payment-required.vue?vue&type=script&lang=js"
export * from "./payment-required.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__